import React from 'react';
 
import AuthUserContext from './context';
import { withFirebase } from '../firebase';


const withAuthentication = Component => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);
 
      this.state = {
        authUser: undefined,
      };
    }
 
    componentDidMount() {
      this.setUser();
      
    }
 
    componentWillUnmount() {
      this.listener();
    }

    setUser = async () => {
      this.listener = await this.props.firebase.auth.onAuthStateChanged(
        authUser => {
          authUser
            ? this.setState({ authUser: authUser })
            : this.setState({ authUser: null });
        },
      );
    }
 
    render() {
      if (this.state.authUser === undefined) {
        return null;
      }

      return (
        <AuthUserContext.Provider value={this.state.authUser}>
          <Component {...this.props} />
        </AuthUserContext.Provider>
      );
    }
  }
 
  return withFirebase(WithAuthentication);
};
 
export default withAuthentication;